export default [

     {
          path: '/crisis-management',
          name: 'CrisisManagement',
          component: () => import("@/views/Page/CrisisManagement/CrisisManagement.vue"),
           meta: {
               title: '#Default# | CrisisManagement',
          },
     }
];